export default __webpack_public_path__ + "static/media/img-56.c1a49d48.jpg";